import type { FaireProductEntity } from "../../entity_types/product";

export const p_hccj8fkgxg: FaireProductEntity = {
  token: "p_hccj8fkgxg",
  type: "product",
  name: "18k Gold PVD Coated Beaded Stainless Steel CZ Stacking Ring",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/8451de35e10dcdc30cc38a6ff18913badf0267652f2580e1debf39de13ae2569.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd57847617a6df451ab4a007e3e4767472cfb03995106149931681d933d09fef.jpeg",
    "https://cdn.faire.com/fastly/15968b3b13d948423da229af3868845265e04434da834189ab95f647216e7703.jpeg",
    "https://cdn.faire.com/fastly/6b65dcb4cbb4db348d89198069694f78b2f6eaa2165742ea2e62118eb9b74685.jpeg",
    "https://cdn.faire.com/fastly/6e8a5ea915185793504ba0ae8ac98e8eac32209c493730cdd1ccf7909e3624f4.jpeg",
    "https://cdn.faire.com/fastly/988de2a76502d633a2bc9a7bebf61861253b8a99fd18046248ca8b98c985eec5.jpeg",
    "https://cdn.faire.com/fastly/a7db7255b93661cc099daee62b5e5bef6c993555e7688d3b477d89e60f105f71.jpeg",
  ],
  priceDollars: 8,
  description:
    "Introducing a sparkling update to our popular Beaded Stainless Steel Stacking Ring! This dainty and elegant ring features a beautiful beaded steel band, and 7 round Cubic Zirconia stones for a sleek and sophisticated effect. Great for stacking or worn on its own, this ring is an exceptional everyday piece. We always PVD coat to our 18K Gold styles for a tarnish resistant, long lasting, beautiful finish.\n\n✦ Strong, durable, and don't easily break.\n✦ 316L Surgical Grade Stainless Steel will never fade, tarnish or turn skin green, even when worn in the ocean or pool.\n✦ Hypoallergenic, so don't worry about any breakouts or rashes!\n✦ A great alternative to .925 Sterling Silver.\n\n- PVD COATING -\nWe use the process of PVD Coating our 18K Gold jewelry over surgical grade 316L stainless steel for a non-tarnish, hypoallergenic finish that will hold up best to everyday wear and will never turn your customer's skin green.\n\nApprox. Width(mm): 3 mm\nApprox. Weight: 2.9 grams",
  tags: [],
  msrpDollars: 72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:36.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
